import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=2d355cfb"
import script from "./BigNumber.vue?vue&type=script&lang=js"
export * from "./BigNumber.vue?vue&type=script&lang=js"
import style0 from "./BigNumber.vue?vue&type=style&index=0&id=2d355cfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports